module.exports = __webpack_public_path__ + "r-v3/img/ico_participant_permission.1d0a7b5f.svg";